(() => {
  'use strict';

  const localeRoot = window.Shopify?.routes?.root || '/';

  function updateCartNotices(cart) {
    if (!cart || !Array.isArray(cart.items) || !Number.isFinite(cart.total_price)) return;
    const subtotal = document.querySelector('#cart .cart__item-subtotal');
    if (subtotal) subtotal.setAttribute('href', localeRoot + 'cart');
    const template = document.getElementById('utopia-order-minimum-template');
    if (subtotal && template && !document.querySelector('#cart [data-order-minimum="cart"]')) {
      subtotal.parentElement.appendChild(template.content.cloneNode(true));
    }
    document.querySelectorAll('[data-order-minimum="cart"]').forEach(notice => {
      notice.hidden = !cart.items.some(item => item.requires_shipping);
      if (notice.hidden) return;
      const message = notice.querySelector('[data-minimum-message]');
      if (cart.currency !== 'CZK') {
        message.textContent = notice.dataset.internationalText;
        return;
      }
      const remaining = Math.max(0, Number(notice.dataset.minimum) - cart.total_price);
      const amount = new Intl.NumberFormat(notice.dataset.locale || 'cs', {
        style: 'currency', currency: 'CZK', minimumFractionDigits: 0, maximumFractionDigits: 2
      }).format(remaining / 100);
      message.textContent = remaining > 0
        ? notice.dataset.remainingText.replace('__AMOUNT__', amount)
        : notice.dataset.reachedText;
    });
  }

  function updateProductNotices() {
    document.querySelectorAll('[data-order-minimum="product"]').forEach(notice => {
      const form = notice.closest('form');
      const selected = form && form.querySelector('[name="id"]');
      if (selected) notice.hidden = !notice.dataset.shippingVariants.trim().split(/\s+/).includes(selected.value);
    });
  }

  if (window.jQuery) {
    window.jQuery.ajaxPrefilter(options => {
      const url = new URL(options.url, window.location.origin);
      if (url.origin === window.location.origin && /^\/cart(?:\/(?:add|change|update|clear))?\.js$/.test(url.pathname)) {
        options.url = localeRoot + url.pathname.slice(1) + url.search;
      }
    });
    window.jQuery(document).on('ajaxSuccess.utopiaOrderMinimum', (_event, xhr, settings) => {
      const path = new URL(settings.url, window.location.origin).pathname;
      if (/\/cart(?:\/(?:change|update|clear))?\.js$/.test(path)) {
        updateCartNotices(xhr.responseJSON);
      }
    });
    window.jQuery(document).on('change.utopiaOrderMinimum', '.product_form select, .product_form input[name="id"]', () => {
      window.setTimeout(updateProductNotices, 0);
    });
  }
  document.addEventListener('shopify:section:load', updateProductNotices);
  updateProductNotices();
})();

